/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Row, Col, Card, Table, notification } from 'antd';
import PieChart from './charts/pieChart';
import ColumnChart from './charts/columnChart';
import LineChart from './charts/lineChart';
import { formatKeyName } from '../../../../utills/helpers';
import Loader from '../../../../components/common/Loader';
import Filters from './filters/CommonFilters';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchDashboardHomeData, saveDashboardHomeFilters } from '../../../auth/slice/authSlice';
import dayjs from 'dayjs';

// CSS styles for the total rows
const totalRowStyle = `
  .total-row {
    font-weight: bold;
  }
`;

const DashboardHome = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isAdmin = useSelector((state) => state?.auth?.isAdmin);
  const dashboardHomeData = useSelector((state) => state?.auth?.dashboardDetails?.data);
  console.log('dashboardHomeData: ', dashboardHomeData);
  
  // Add the CSS styles to the document
  useEffect(() => {
    const styleElement = document.createElement('style');
    styleElement.innerHTML = totalRowStyle;
    document.head.appendChild(styleElement);
    
    return () => {
      document.head.removeChild(styleElement);
    };
  }, []);

  const [isLoading, setIsLoading] = useState(false);
  const [filters, setFilters] = useState({
    userId: '',
    modelNo: '',
    startDate: '',
    endDate: '',
    // month_id: '',
    // year_id: '',
  });
  console.log(filters, 'filters');
  const roleType = useSelector((state) => state?.auth?.userData?.role);
  console.log(roleType, 'roleType');
  const route = isAdmin ? '/admin' : '';
  const checkUserName = roleType === 'Exchange Evaluation Team' || roleType === "Procurement Manager";
  const exchangeRoute = checkUserName ? '/exchange-lead' : '';

  const shouldHideAreaTable = roleType === 'Sales Manager' || roleType === 'Team Leader' || roleType === 'Sales Officer' || roleType === 'Exchange Evaluation Team' || roleType === "Procurement Manager" ;

  useEffect(() => {
    // const queryStringValue = generateQueryString(reduxFilters);
    // setQueryString(queryStringValue);
    dispatch(saveDashboardHomeFilters(filters));
    if (roleType === 'Head Office Manager' || filters?.userId || filters?.modelNo || filters?.startDate || filters?.endDate) {
      getDashboardHomeDetails(filters);
    }

  }, [filters]);

  //Api call to get dashboard home data
  const getDashboardHomeDetails = async () => {
    setIsLoading(true);
    try {
      const reqData = {
        userId: filters?.userId ? filters?.userId : '',
        modelId: filters?.modelNo ? filters?.modelNo : '',
        startDate: filters?.startDate ? dayjs(filters?.startDate).format('YYYY-MM-DD') : '',
        endDate: filters?.endDate ? dayjs(filters?.endDate).format('YYYY-MM-DD') : '',
        checkUserName,
      };
      // const response = await getDashboardHomeData(reqData);
      // setDashboardHomeData(response && response?.data && response?.data?.data);
      await dispatch(fetchDashboardHomeData(reqData));
    } catch (error) {
      notification.error({
        description: error.response?.data?.message ?? error?.message,
      });
    } finally {
      setIsLoading(false);
    }
  };

  // Pie Chart Lead Funel (Lead Type) Data
  const leadTypes = dashboardHomeData && dashboardHomeData?.lead_type;
  const dataChartLeadType = [
    ['Lead Type', 'Lead Counts'],
    ['Live Leads', leadTypes?.live_leads],
    ['Hot Leads', leadTypes?.hot],
    ['Warm Leads', leadTypes?.warm],
    ['Cold Leads', leadTypes?.cold],
  ];

  // Pie Chart Lead Funel (Lead Stage) Data
  const leadStage = dashboardHomeData && dashboardHomeData?.lead_stage;
  const dataChartLeadStage = [
    ['Lead Stage', 'Lead Counts'],
    ['Booked', leadStage?.booked],
    ['Pre Sales', leadStage?.preSales],
    ['Procured', leadStage?.procured],
    ['Retailed', leadStage?.retailed],
  ];

  // Common function to format API data into chart data format
  const formatDataForChart = (data, keys) => {
    return data && data?.map((item) => keys?.map((key) => item[key]));
  };

  // Format the data for the chart
  const formattedChartData = dashboardHomeData?.lead_quotation_breakup
    ? [
      ['Days', 'Lead Count', { role: 'annotation' }, 'Quotation Sent', { role: 'annotation' }],
      ...formatDataForChart(dashboardHomeData?.lead_quotation_breakup, [
        'interval',
        'lead_count',
        'lead_count',
        'quotation_count',
        'quotation_count',
      ]),
    ]
    : [];
console.log(formattedChartData,'formattedChartData')
  const formattedRetailerData = dashboardHomeData?.retail_breakup
    ? [
      ['Cars', 'Retail Number', { role: 'annotation' }],
      ...formatDataForChart(dashboardHomeData?.retail_breakup, ['model_name', 'model_count', 'model_count']),
    ]
    : [];

  const onPieChartSegmentClick = (selectedItem) => {
    const segmentLabel = selectedItem[0];
    console.log('segmentLabel: ', segmentLabel);
    PieChartRedirect(segmentLabel);
  };

  const PieChartRedirect = (segmentLabel) => {
    if (segmentLabel === 'Live Leads') {
      navigate(`${route}/leads${exchangeRoute}?lead_type=10&key=hot_lead`);
    } else if (segmentLabel === 'Hot Leads') {
      navigate(`${route}/leads${exchangeRoute}?lead_type=1&key=hot_lead`);
    } else if (segmentLabel === 'Warm Leads') {
      navigate(`${route}/leads${exchangeRoute}?lead_type=2&key=hot_lead`);
    } else if (segmentLabel === 'Cold Leads') {
      navigate(`${route}/leads${exchangeRoute}?lead_type=3&key=hot_lead`);
    } else if (segmentLabel === 'Pre Sales') {
      navigate(`${route}/leads${exchangeRoute}?lead_stage=1&key=hot_lead&lead_funnel_redirect=true`);
    } else if (segmentLabel === 'Booked') {
      navigate(`${route}/leads${exchangeRoute}?lead_stage=2&key=hot_lead&lead_funnel_redirect=true`);
    } else if (segmentLabel === 'Retailed') {
      navigate(`${route}/leads${exchangeRoute}?lead_stage=3&key=hot_lead&lead_funnel_redirect=true`);
    } else if (segmentLabel === 'Procured') {
      navigate(`${route}/leads${exchangeRoute}?lead_stage=4&key=hot_lead&lead_funnel_redirect=true`);
    }
  };

  const handleCardClick = (ele, originalKey = '') => {
    const param = ele?.toLowerCase()?.split(' ')?.join('_');

    // Head Office Manager specific redirects
    if (roleType === 'Head Office Manager') {
      if (originalKey === 'pending_document_collection_requests') {
        navigate(`${route}/leads${exchangeRoute}?document_collection_pending=true&dashboard_redirect=true&key=hot_lead`);
        return;
      } else if (originalKey === 'pending_delivery_approval_requests') {
        navigate(`${route}/leads${exchangeRoute}?delivery_approval_pending=true&dashboard_redirect=true&key=hot_lead`);
        return;
      }
    }

    if (param === 'phone_call') {
      navigate(`${route}/leads?follow_up_date_id=1&key=hot_lead`);
    } else if (param === 'pending_for_procurement') {
      navigate(`${route}/leads${exchangeRoute}?need_procured="true"&key=hot_lead`);
    } else if (param === 'pending_for_valuation') {
      navigate(`${route}/leads${exchangeRoute}?need_evaluation="true"&key=hot_lead`);
    } else if (param === 'total') {
      navigate(`${route}/leads${exchangeRoute}?need_evaluation="true"&need_procured="true"&key=hot_lead`);
    }
  };

  // Task Ageing Table Column
  const task_ageing_column = [
    {
      title: 'Pending Task',
      dataIndex: 'label',
      key: 'label',
    },
    {
      title: '> 1 Day',
      dataIndex: 'greater_than_one_day',
      key: 'greater_than_one_day',
      render: (text) => (
        <>
          {/* <a
            href={`${route}/leads?greater_than_one_day="true"&key=hot_lead`}
            style={{ cursor: "pointer" }}
          >
            {text}
          </a> */}
          {+text !== 0 ? (
            <a href={`${route}/leads?greater_than_one_day="true"&key=hot_lead`} style={{ cursor: 'pointer' }}>
              {text}
            </a>
          ) : (
            text
          )}
        </>
      ),
    },
    {
      title: '> 10 Day',
      dataIndex: 'greater_than_ten_day',
      key: 'greater_than_ten_day',
      render: (text) => (
        <>
          {/* <a
            href={`${route}/leads?greater_than_ten_day="true"&key=hot_lead`}
            style={{ cursor: "pointer" }}
          >
            {text}
          </a> */}
          {+text !== 0 ? (
            <a href={`${route}/leads?greater_than_ten_day="true"&key=hot_lead`} style={{ cursor: 'pointer' }}>
              {text}
            </a>
          ) : (
            text
          )}
        </>
      ),
    },
    {
      title: '> 20 Day',
      dataIndex: 'greater_than_twenty_day',
      key: 'greater_than_twenty_day',
      render: (text) => (
        <>
          {/* <a
            href={`${route}/leads?greater_than_twenty_day="true"&key=hot_lead`}
            style={{ cursor: "pointer" }}
          >
            {text}
          </a> */}
          {+text !== 0 ? (
            <a href={`${route}/leads?greater_than_twenty_day="true"&key=hot_lead`} style={{ cursor: 'pointer' }}>
              {text}
            </a>
          ) : (
            text
          )}
        </>
      ),
    },
  ];

  // Enquiry Source Table Column
  const columnsEnquiry = [
    {
      title: 'Enquiry Source',
      dataIndex: 'enquiry_source',
      key: 'enquiry_source',
    },
    {
      title: 'Enquiry',
      dataIndex: 'enquiry',
      key: 'enquiry',
      className: 'text-center',
      render: (text, record) =>
        record?.enquiry_source === 'Total' ? (
          text
        ) : (
          <>
            {+text !== 0 ? (
              <a
                // href={`${route}/leads?lead_source=${record?.enquiry_source_id}&key=hot_lead&lead_stage=1`}
                href={`${route}/leads?lead_source=${record?.enquiry_source_id}&key=hot_lead`}
                style={{ cursor: 'pointer' }}
              >
                {text}
              </a>
            ) : (
              text
            )}
          </>
        ),
    },
    {
      title: 'Test Drive',
      dataIndex: 'test_drive',
      key: 'test_drive',
      className: 'text-center',
      render: (text, record) =>
        record?.enquiry_source === 'Total' ? (
          text
        ) : (
          <>
            {text !== 0 ? (
              <a
                href={`${route}/leads?lead_source=${record?.enquiry_source_id}&key=hot_lead&test_drive_completed="true"`}
                style={{ cursor: 'pointer' }}
              >
                {text}
              </a>
            ) : (
              text
            )}
          </>
        ),
    },
    {
      title: 'Home Visit',
      dataIndex: 'home_visit',
      key: 'home_visit',
      className: 'text-center',
      render: (text, record) =>
        record?.enquiry_source === 'Total' ? (
          text
        ) : (
          <>
            {text !== 0 ? (
              <a
                href={`${route}/leads?lead_source=${record?.enquiry_source_id}&key=hot_lead&home_visit_completed="true"`}
                style={{ cursor: 'pointer' }}
              >
                {text}
              </a>
            ) : (
              text
            )}
          </>
        ),
    },
    {
      title: 'Booking',
      dataIndex: 'booking',
      key: 'booking',
      className: 'text-center',
      render: (text, record) =>
        record?.enquiry_source === 'Total' ? (
          text
        ) : (
          <>
            {text !== 0 ? (
              <a
                // href={`${route}/leads?lead_source=${record?.enquiry_source_id}&lead_stage=2&key=hot_lead`}
                href={`${route}/leads?lead_source=${record?.enquiry_source_id}&key=hot_lead&booking_completed="true"`}
                style={{ cursor: 'pointer' }}
              >
                {text}
              </a>
            ) : (
              text
            )}
          </>
        ),
    },
    {
      title: 'Retail',
      dataIndex: 'retail',
      key: 'retail',
      className: 'text-center',
      render: (text, record) =>
        record?.enquiry_source === 'Total' ? (
          text
        ) : (
          <>
            {text !== 0 ? (
              <a
                href={`${route}/leads?lead_source=${record?.enquiry_source_id}&lead_stage=3&key=hot_lead`}
                style={{ cursor: 'pointer' }}
              >
                {text}
              </a>
            ) : (
              text
            )}
          </>
        ),
    },
    {
      title: 'Exchange',
      dataIndex: 'exchange',
      key: 'exchange',
      className: 'text-center',
      render: (text, record) =>
        record?.enquiry_source === 'Total' ? (
          text
        ) : (
          <>
            {text !== 0 ? (
              <a
                href={`${route}/leads?lead_source=${record?.enquiry_source_id}&key=hot_lead&exchange_car="true"`}
                style={{ cursor: 'pointer' }}
              >
                {text}
              </a>
            ) : (
              text
            )}
          </>
        ),
    },
    {
      title: 'Valuation',
      dataIndex: 'valuation',
      key: 'valuation',
      className: 'text-center',
      render: (text, record) =>
        record?.enquiry_source === 'Total' ? (
          text
        ) : (
          <>
            {text !== 0 ? (
              <a
                href={`${route}/leads?lead_source=${record?.enquiry_source_id}&key=hot_lead&evaluation_completed="true"`}
                style={{ cursor: 'pointer' }}
              >
                {text}
              </a>
            ) : (
              text
            )}
          </>
        ),
    },
    {
      title: 'Procured',
      dataIndex: 'procured',
      key: 'procured',
      className: 'text-center',
      render: (text, record) =>
        record?.enquiry_source === 'Total' ? (
          text
        ) : (
          <>
            {text !== 0 ? (
              <a
                href={`${route}/leads?lead_source=${record?.enquiry_source_id}&procured="true"&key=hot_lead`}
                style={{ cursor: 'pointer' }}
              >
                {text}
              </a>
            ) : (
              text
            )}
          </>
        ),
    },
    {
      title: 'Lost',
      dataIndex: 'lost',
      key: 'lost',
      className: 'text-center',
      render: (text, record) =>
        record?.enquiry_source === 'Total' ? (
          text
        ) : (
          <>
            {text !== 0 ? (
              <a
                href={`${route}/leads?lead_source=${record?.enquiry_source_id}&lead_status=3&key=hot_lead`}
                style={{ cursor: 'pointer' }}
              >
                {text}
              </a>
            ) : (
              text
            )}
          </>
        ),
    },
  ];

  // Model Table Column
  const columnsModel = [
    {
      title: 'Model',
      dataIndex: 'model_name',
      key: 'model_name',
      // render: (text, record) =>
      //   record?.model_name === 'Total' ? (
      //     text
      //   ) : (
      //     // <a 
      //     //   href={getRedirectUrl(`${route}/leads?model_id=${record?.model_id}&key=hot_lead`)} 
      //     //   style={{ cursor: 'pointer' }}
      //     // >
      //       {text}
      //     // </a>
      //   ),
    },
    {
      title: 'Enquiry',
      dataIndex: 'enquiry',
      key: 'enquiry',
      className: 'text-center',
      render: (text, record) =>
        record?.model_name === 'Total' ? (
          text
        ) : (
          <>
            {+text !== 0 ? (
              <a
                href={getRedirectUrl(`${route}/leads?model_id=${record?.model_id}&key=hot_lead`)}
                style={{ cursor: 'pointer' }}
              >
                {text}
              </a>
            ) : (
              text
            )}
          </>
        ),
    },
    {
      title: 'Test Drive',
      dataIndex: 'test_drive',
      key: 'test_drive',
      className: 'text-center',
      render: (text, record) =>
        record?.model_name === 'Total' ? (
          text
        ) : (
          <>
            {text !== 0 ? (
              <a
                href={getRedirectUrl(`${route}/leads?model_id=${record?.model_id}&key=hot_lead&test_drive_completed="true"`)}
                style={{ cursor: 'pointer' }}
              >
                {text}
              </a>
            ) : (
              text
            )}
          </>
        ),
    },
    {
      title: 'Home Visit',
      dataIndex: 'home_visit',
      key: 'home_visit',
      className: 'text-center',
      render: (text, record) =>
        record?.model_name === 'Total' ? (
          text
        ) : (
          <>
            {text !== 0 ? (
              <a
                href={getRedirectUrl(`${route}/leads?model_id=${record?.model_id}&key=hot_lead&home_visit_completed="true"`)}
                style={{ cursor: 'pointer' }}
              >
                {text}
              </a>
            ) : (
              text
            )}
          </>
        ),
    },
    {
      title: 'Booking',
      dataIndex: 'booking',
      key: 'booking',
      className: 'text-center',
      render: (text, record) =>
        record?.model_name === 'Total' ? (
          text
        ) : (
          <>
            {text !== 0 ? (
              <a
                href={getRedirectUrl(`${route}/leads?model_id=${record?.model_id}&key=hot_lead&booking_completed="true"`)}
                style={{ cursor: 'pointer' }}
              >
                {text}
              </a>
            ) : (
              text
            )}
          </>
        ),
    },
    {
      title: 'Retail',
      dataIndex: 'retail',
      key: 'retail',
      className: 'text-center',
      render: (text, record) =>
        record?.model_name === 'Total' ? (
          text
        ) : (
          <>
            {text !== 0 ? (
              <a
                href={getRedirectUrl(`${route}/leads?model_id=${record?.model_id}&lead_stage=3&key=hot_lead`)}
                style={{ cursor: 'pointer' }}
              >
                {text}
              </a>
            ) : (
              text
            )}
          </>
        ),
    },
    {
      title: 'Exchange',
      dataIndex: 'exchange',
      key: 'exchange',
      className: 'text-center',
      render: (text, record) =>
        record?.model_name === 'Total' ? (
          text
        ) : (
          <>
            {text !== 0 ? (
              <a
                href={getRedirectUrl(`${route}/leads?model_id=${record?.model_id}&key=hot_lead&exchange_car="true"`)}
                style={{ cursor: 'pointer' }}
              >
                {text}
              </a>
            ) : (
              text
            )}
          </>
        ),
    },
    {
      title: 'Valuation',
      dataIndex: 'valuation',
      key: 'valuation',
      className: 'text-center',
      render: (text, record) =>
        record?.model_name === 'Total' ? (
          text
        ) : (
          <>
            {text !== 0 ? (
              <a
                href={getRedirectUrl(`${route}/leads?model_id=${record?.model_id}&key=hot_lead&evaluation_completed="true"`)}
                style={{ cursor: 'pointer' }}
              >
                {text}
              </a>
            ) : (
              text
            )}
          </>
        ),
    },
    {
      title: 'Procured',
      dataIndex: 'procured',
      key: 'procured',
      className: 'text-center',
      render: (text, record) =>
        record?.model_name === 'Total' ? (
          text
        ) : (
          <>
            {text !== 0 ? (
              <a
                href={getRedirectUrl(`${route}/leads?model_id=${record?.model_id}&procured="true"&key=hot_lead`)}
                style={{ cursor: 'pointer' }}
              >
                {text}
              </a>
            ) : (
              text
            )}
          </>
        ),
    },
    {
      title: 'Lost',
      dataIndex: 'lost',
      key: 'lost',
      className: 'text-center',
      render: (text, record) =>
        record?.model_name === 'Total' ? (
          text
        ) : (
          <>
            {text !== 0 ? (
              <a
                href={getRedirectUrl(`${route}/leads?model_id=${record?.model_id}&lead_status=3&key=hot_lead`)}
                style={{ cursor: 'pointer' }}
              >
                {text}
              </a>
            ) : (
              text
            )}
          </>
        ),
    },
  ];

  // Area Table Column
  const columnsArea = [
    {
      title: 'Lead Owner Area',
      dataIndex: 'area_name',
      key: 'area_name',
      // render: (text, record) =>
      //   record?.area_name === 'Total' ? (
      //     text
      //   ) : (
      //     <a 
      //       href={getRedirectUrl(`${route}/leads?area_id=${record?.area_id}&key=hot_lead`)} 
      //       style={{ cursor: 'pointer' }}
      //     >
      //       {text}
      //     </a>
      //   ),
    },
    {
      title: 'Enquiry',
      dataIndex: 'enquiry',
      key: 'enquiry',
      className: 'text-center',
      render: (text, record) =>
        record?.area_name === 'Total' ? (
          text
        ) : (
          <>
            {+text !== 0 ? (
              <a
                href={getRedirectUrl(`${route}/leads?area_id=${record?.area_id}&key=hot_lead`)}
                style={{ cursor: 'pointer' }}
              >
                {text}
              </a>
            ) : (
              text
            )}
          </>
        ),
    },
    {
      title: 'Test Drive',
      dataIndex: 'test_drive',
      key: 'test_drive',
      className: 'text-center',
      render: (text, record) =>
        record?.area_name === 'Total' ? (
          text
        ) : (
          <>
            {text !== 0 ? (
              <a
                href={getRedirectUrl(`${route}/leads?area_id=${record?.area_id}&key=hot_lead&test_drive_completed="true"`)}
                style={{ cursor: 'pointer' }}
              >
                {text}
              </a>
            ) : (
              text
            )}
          </>
        ),
    },
    {
      title: 'Home Visit',
      dataIndex: 'home_visit',
      key: 'home_visit',
      className: 'text-center',
      render: (text, record) =>
        record?.area_name === 'Total' ? (
          text
        ) : (
          <>
            {text !== 0 ? (
              <a
                href={getRedirectUrl(`${route}/leads?area_id=${record?.area_id}&key=hot_lead&home_visit_completed="true"`)}
                style={{ cursor: 'pointer' }}
              >
                {text}
              </a>
            ) : (
              text
            )}
          </>
        ),
    },
    {
      title: 'Booking',
      dataIndex: 'booking',
      key: 'booking',
      className: 'text-center',
      render: (text, record) =>
        record?.area_name === 'Total' ? (
          text
        ) : (
          <>
            {text !== 0 ? (
              <a
                href={getRedirectUrl(`${route}/leads?area_id=${record?.area_id}&key=hot_lead&booking_completed="true"`)}
                style={{ cursor: 'pointer' }}
              >
                {text}
              </a>
            ) : (
              text
            )}
          </>
        ),
    },
    {
      title: 'Retail',
      dataIndex: 'retail',
      key: 'retail',
      className: 'text-center',
      render: (text, record) =>
        record?.area_name === 'Total' ? (
          text
        ) : (
          <>
            {text !== 0 ? (
              <a
                href={getRedirectUrl(`${route}/leads?area_id=${record?.area_id}&lead_stage=3&key=hot_lead`)}
                style={{ cursor: 'pointer' }}
              >
                {text}
              </a>
            ) : (
              text
            )}
          </>
        ),
    },
    {
      title: 'Exchange',
      dataIndex: 'exchange',
      key: 'exchange',
      className: 'text-center',
      render: (text, record) =>
        record?.area_name === 'Total' ? (
          text
        ) : (
          <>
            {text !== 0 ? (
              <a
                href={getRedirectUrl(`${route}/leads?area_id=${record?.area_id}&key=hot_lead&exchange_car="true"`)}
                style={{ cursor: 'pointer' }}
              >
                {text}
              </a>
            ) : (
              text
            )}
          </>
        ),
    },
    {
      title: 'Valuation',
      dataIndex: 'valuation',
      key: 'valuation',
      className: 'text-center',
      render: (text, record) =>
        record?.area_name === 'Total' ? (
          text
        ) : (
          <>
            {text !== 0 ? (
              <a
                href={getRedirectUrl(`${route}/leads?area_id=${record?.area_id}&key=hot_lead&evaluation_completed="true"`)}
                style={{ cursor: 'pointer' }}
              >
                {text}
              </a>
            ) : (
              text
            )}
          </>
        ),
    },
    {
      title: 'Procured',
      dataIndex: 'procured',
      key: 'procured',
      className: 'text-center',
      render: (text, record) =>
        record?.area_name === 'Total' ? (
          text
        ) : (
          <>
            {text !== 0 ? (
              <a
                href={getRedirectUrl(`${route}/leads?area_id=${record?.area_id}&procured="true"&key=hot_lead`)}
                style={{ cursor: 'pointer' }}
              >
                {text}
              </a>
            ) : (
              text
            )}
          </>
        ),
    },
    {
      title: 'Lost',
      dataIndex: 'lost',
      key: 'lost',
      className: 'text-center',
      render: (text, record) =>
        record?.area_name === 'Total' ? (
          text
        ) : (
          <>
            {text !== 0 ? (
              <a
                href={getRedirectUrl(`${route}/leads?area_id=${record?.area_id}&lead_status=3&key=hot_lead`)}
                style={{ cursor: 'pointer' }}
              >
                {text}
              </a>
            ) : (
              text
            )}
          </>
        ),
    },
  ];

  // Helper function to create URL with dashboard redirect parameters
  const getRedirectUrl = (baseUrl) => {
    // Replace user_id with lead_owned in the URL
    const updatedUrl = baseUrl.replace('user_id=', 'lead_owned=');
    return `${updatedUrl}&dashboard_redirect=true&start_date=${filters?.startDate ? dayjs(filters?.startDate).format('YYYY-MM-DD') : ''}&end_date=${filters?.endDate ? dayjs(filters?.endDate).format('YYYY-MM-DD') : ''}`;
  };

  // Prepare user table data from API response for Super Admin
  const prepareUserTableData = () => {
    if (!dashboardHomeData?.user_table?.data) return [];
    
    const flattenedData = [];
    
    dashboardHomeData?.user_table?.data?.forEach((areaManagerData, areaIndex) => {
      // Track the starting index for this area manager's rows
      const areaStartIndex = flattenedData.length;
      let areaRowCount = 0;
      
      // Add reporting managers and their lead owners
      areaManagerData?.reportingManagers?.forEach(reportingManagerData => {
        // Track the starting index for this reporting manager's rows
        const reportingManagerStartIndex = flattenedData.length;
        let reportingManagerRowCount = 0;
        
        // Add lead owners first
        reportingManagerData?.leadOwners?.forEach(leadOwner => {
          flattenedData.push({
            key: `lead_${leadOwner?.user_id}_${areaIndex}`,
            areaManager: '',  // Will be filled by rowSpan
            reportingManager: '',  // Will be filled by rowSpan
            leadOwner: leadOwner?.user_name,
            user_id: leadOwner?.user_id,
            enquiry: leadOwner?.enquiry,
            test_drive: leadOwner?.test_drive,
            home_visit: leadOwner?.home_visit,
            booking: leadOwner?.booking,
            retail: leadOwner?.retail,
            exchange: leadOwner?.exchange,
            valuation: leadOwner?.valuation,
            procured: leadOwner?.procured,
            lost: leadOwner?.lost,
          });
          areaRowCount++;
          reportingManagerRowCount++;
        });
        
        // Add reporting manager total row
        flattenedData.push({
          key: `reporting_${reportingManagerData?.total?.user_id}_${areaIndex}`,
          areaManager: '',  // Will be filled by rowSpan
          reportingManager: `${reportingManagerData?.name} Total`,
          leadOwner: '',
          user_id: reportingManagerData?.total?.user_id,
          enquiry: reportingManagerData?.total?.enquiry,
          test_drive: reportingManagerData?.total?.test_drive,
          home_visit: reportingManagerData?.total?.home_visit,
          booking: reportingManagerData?.total?.booking,
          retail: reportingManagerData?.total?.retail,
          exchange: reportingManagerData?.total?.exchange,
          valuation: reportingManagerData?.total?.valuation,
          procured: reportingManagerData?.total?.procured,
          lost: reportingManagerData?.total?.lost,
          isTotal: true, // Flag for styling
        });
        areaRowCount++;
        reportingManagerRowCount++;
        
        // Set the reporting manager name only in the first row with rowSpan
        if (reportingManagerRowCount > 0 && flattenedData[reportingManagerStartIndex]) {
          flattenedData[reportingManagerStartIndex].reportingManager = reportingManagerData?.name;
          flattenedData[reportingManagerStartIndex].reportingManagerRowSpan = reportingManagerRowCount - 1; // Exclude the total row which shows the name again
        }
      });
      
      // Add area manager total row
      flattenedData.push({
        key: `area_${areaManagerData?.total?.user_id}_${areaIndex}`,
        areaManager: areaManagerData?.areaManager,
        reportingManager: `${areaManagerData?.areaManager} Total`,
        leadOwner: '',
        user_id: areaManagerData?.total?.user_id,
        enquiry: areaManagerData?.total?.enquiry,
        test_drive: areaManagerData?.total?.test_drive,
        home_visit: areaManagerData?.total?.home_visit,
        booking: areaManagerData?.total?.booking,
        retail: areaManagerData?.total?.retail,
        exchange: areaManagerData?.total?.exchange,
        valuation: areaManagerData?.total?.valuation,
        procured: areaManagerData?.total?.procured,
        lost: areaManagerData?.total?.lost,
        isTotal: true, // Flag for styling
      });
      areaRowCount++;
      
      // Set the area manager name only in the first row with rowSpan
      if (areaRowCount > 0 && flattenedData[areaStartIndex]) {
        flattenedData[areaStartIndex].areaManager = areaManagerData?.areaManager;
        flattenedData[areaStartIndex].areaManagerRowSpan = areaRowCount - 1; // Exclude the total row which shows the name again
      }
    });
    
    // Add grand total row
    if (dashboardHomeData?.user_table?.grandTotal) {
      flattenedData.push({
        key: 'grand_total',
        
        areaManager: dashboardHomeData?.user_table?.grandTotal?.user_name,
        reportingManager: '',
        leadOwner: '',
        user_id: '',
        enquiry: dashboardHomeData?.user_table?.grandTotal?.enquiry,
        test_drive: dashboardHomeData?.user_table?.grandTotal?.test_drive,
        home_visit: dashboardHomeData?.user_table?.grandTotal?.home_visit,
        booking: dashboardHomeData?.user_table?.grandTotal?.booking,
        retail: dashboardHomeData?.user_table?.grandTotal?.retail,
        exchange: dashboardHomeData?.user_table?.grandTotal?.exchange,
        valuation: dashboardHomeData?.user_table?.grandTotal?.valuation,
        procured: dashboardHomeData?.user_table?.grandTotal?.procured,
        lost:  dashboardHomeData?.user_table?.grandTotal?.lost,
        isTotal: true, // Flag for styling
      });

      
    }
    
    return flattenedData;
  };

  // User Table Column with cell merging
  const columnsUserTable = [
    {
      title: 'Area Manager',
      dataIndex: 'areaManager',
      key: 'areaManager',
      render: (text) => {
        return text;

       
        
        // // Apply rowSpan if defined
        // if (record.areaManagerRowSpan) {
        //   const obj = {
        //     children: text,
        //     props: { rowSpan: record.areaManagerRowSpan },
        //   };
          
        //   // Hide cells that should be merged
        //   // if (record.areaManagerRowSpan === 0) {
        //   //   obj.props.rowSpan = 0;
        //   // }
          
        //   return obj;
        // } else if (!text) {
        //   // Hide cells that should be merged
        //   obj.props.rowSpan = 0;
        // }
        
        // return obj;
      },
    },
    {
      title: 'Lead Owner Reporting Manager',
      dataIndex: 'reportingManager',
      key: 'reportingManager',
      render: (text) => {

        return text;
        
        // const obj = {
        //   children: text,
        //   props: {},
        // };
        
        // // Apply rowSpan if defined
        // if (record.reportingManagerRowSpan) {
        //   obj.props.rowSpan = record.reportingManagerRowSpan;
        // } else if (!text) {
        //   // Hide cells that should be merged
        //   obj.props.rowSpan = 0;
        // }
        
        // return obj;
      },
    },
    {
      title: 'Lead Owner',
      dataIndex: 'leadOwner',
      key: 'leadOwner',
    },   
    {
      title: 'Enquiry',
      dataIndex: 'enquiry',
      key: 'enquiry',
      className: 'text-center',
      render: (text, record) => (
        <>
          {text !== 0 && !record.isTotal ? (
            <a
              href={getRedirectUrl(`${route}/leads?user_id=${record?.user_id}&key=hot_lead`)}
              style={{ cursor: 'pointer' }}
            >
              {text}
            </a>
          ) : (
            text
          )}
        </>
      ),
    },
    {
      title: 'Test Drive',
      dataIndex: 'test_drive',
      key: 'test_drive',
      className: 'text-center',
      render: (text, record) => (
        <>
          {text !== 0 && !record.isTotal ? (
            <a
              href={getRedirectUrl(`${route}/leads?user_id=${record?.user_id}&key=hot_lead&test_drive_completed="true"`)}
              style={{ cursor: 'pointer' }}
            >
              {text}
            </a>
          ) : (
            text
          )}
        </>
      ),
    },
    {
      title: 'Home Visit',
      dataIndex: 'home_visit',
      key: 'home_visit',
      className: 'text-center',
      render: (text, record) => (
        <>
          {text !== 0 && !record.isTotal ? (
            <a
              href={getRedirectUrl(`${route}/leads?user_id=${record?.user_id}&key=hot_lead&home_visit_completed="true"`)}
              style={{ cursor: 'pointer' }}
            >
              {text}
            </a>
          ) : (
            text
          )}
        </>
      ),
    },
    {
      title: 'Booking',
      dataIndex: 'booking',
      key: 'booking',
      className: 'text-center',
      render: (text, record) => (
        <>
          {text !== 0 && !record.isTotal ? (
            <a
              href={getRedirectUrl(`${route}/leads?user_id=${record?.user_id}&key=hot_lead&booking_completed="true"`)}
              style={{ cursor: 'pointer' }}
            >
              {text}
            </a>
          ) : (
            text
          )}
        </>
      ),
    },
    {
      title: 'Retail',
      dataIndex: 'retail',
      key: 'retail',
      className: 'text-center',
      render: (text, record) => (
        <>
          {text !== 0 && !record.isTotal ? (
            <a
              href={getRedirectUrl(`${route}/leads?user_id=${record?.user_id}&lead_stage=3&key=hot_lead`)}
              style={{ cursor: 'pointer' }}
            >
              {text}
            </a>
          ) : (
            text
          )}
        </>
      ),
    },
    {
      title: 'Exchange',
      dataIndex: 'exchange',
      key: 'exchange',
      className: 'text-center',
      render: (text, record) => (
        <>
          {text !== 0 && !record.isTotal ? (
            <a
              href={getRedirectUrl(`${route}/leads?user_id=${record?.user_id}&key=hot_lead&exchange_car="true"`)}
              style={{ cursor: 'pointer' }}
            >
              {text}
            </a>
          ) : (
            text
          )}
        </>
      ),
    },
    {
      title: 'Valuation',
      dataIndex: 'valuation',
      key: 'valuation',
      className: 'text-center',
      render: (text, record) => (
        <>
          {text !== 0 && !record.isTotal ? (
            <a
              href={getRedirectUrl(`${route}/leads?user_id=${record?.user_id}&key=hot_lead&evaluation_completed="true"`)}
              style={{ cursor: 'pointer' }}
            >
              {text}
            </a>
          ) : (
            text
          )}
        </>
      ),
    },
    {
      title: 'Procured',
      dataIndex: 'procured',
      key: 'procured',
      className: 'text-center',
      render: (text, record) => (
        <>
          {text !== 0 && !record.isTotal ? (
            <a
              href={getRedirectUrl(`${route}/leads?user_id=${record?.user_id}&procured="true"&key=hot_lead`)}
              style={{ cursor: 'pointer' }}
            >
              {text}
            </a>
          ) : (
            text
          )}
        </>
      ),
    },
    {
      title: 'Lost',
      dataIndex: 'lost',
      key: 'lost',
      className: 'text-center',
      render: (text, record) => (
        <>
          {text !== 0 && !record.isTotal ? (
            <a
              href={getRedirectUrl(`${route}/leads?user_id=${record?.user_id}&lead_status=3&key=hot_lead`)}
              style={{ cursor: 'pointer' }}
            >
              {text}
            </a>
          ) : (
            text
          )}
        </>
      ),
    },
  ];

  // Check if user is Super Admin or Sales Manager to show User Table
  const isSuperAdmin = roleType === 'Super Admin' || roleType === 'CEO' || roleType === 'VP Sales' || roleType === 'GM (General Manager)' || roleType === 'AGM (Assistant General Manager)'|| roleType === 'TSM (Territory Sales Manager)' ;
  const isSalesManager = roleType === 'Sales Manager';
  const isTeamLeader = roleType === 'Team Leader';
  const shouldShowUserTable = (isSuperAdmin || isSalesManager || isTeamLeader) && dashboardHomeData?.user_table?.data;

  // Sales Manager User Table columns
  const columnsSalesManagerUserTable = [
    {
      title: 'Team Leader',
      dataIndex: 'teamLeader',
      key: 'teamLeader',
      render: (text, record) => {
        const obj = {
          children: text,
          props: {},
        };
        
        // Apply rowSpan if defined
        if (record.teamLeaderRowSpan) {
          obj.props.rowSpan = record.teamLeaderRowSpan;
        } else if (!text) {
          // Hide cells that should be merged
          obj.props.rowSpan = 0;
        }
        
        return obj;
      },
    },
    {
      title: 'Lead Owner',
      dataIndex: 'leadOwner',
      key: 'leadOwner',
    },
    {
      title: 'Enquiry',
      dataIndex: 'enquiry',
      key: 'enquiry',
      className: 'text-center',
      render: (text, record) => (
        <>
          {text !== 0 && !record.isTotal ? (
            <a
              href={getRedirectUrl(`${route}/leads?user_id=${record?.user_id}&key=hot_lead`)}
              style={{ cursor: 'pointer' }}
            >
              {text}
            </a>
          ) : (
            text
          )}
        </>
      ),
    },
    {
      title: 'Test Drive',
      dataIndex: 'test_drive',
      key: 'test_drive',
      className: 'text-center',
      render: (text, record) => (
        <>
          {text !== 0 && !record.isTotal ? (
            <a
              href={getRedirectUrl(`${route}/leads?user_id=${record?.user_id}&key=hot_lead&test_drive_completed="true"`)}
              style={{ cursor: 'pointer' }}
            >
              {text}
            </a>
          ) : (
            text
          )}
        </>
      ),
    },
    {
      title: 'Home Visit',
      dataIndex: 'home_visit',
      key: 'home_visit',
      className: 'text-center',
      render: (text, record) => (
        <>
          {text !== 0 && !record.isTotal ? (
            <a
              href={getRedirectUrl(`${route}/leads?user_id=${record?.user_id}&key=hot_lead&home_visit_completed="true"`)}
              style={{ cursor: 'pointer' }}
            >
              {text}
            </a>
          ) : (
            text
          )}
        </>
      ),
    },
    {
      title: 'Booking',
      dataIndex: 'booking',
      key: 'booking',
      className: 'text-center',
      render: (text, record) => (
        <>
          {text !== 0 && !record.isTotal ? (
            <a
              href={getRedirectUrl(`${route}/leads?user_id=${record?.user_id}&key=hot_lead&booking_completed="true"`)}
              style={{ cursor: 'pointer' }}
            >
              {text}
            </a>
          ) : (
            text
          )}
        </>
      ),
    },
    {
      title: 'Retail',
      dataIndex: 'retail',
      key: 'retail',
      className: 'text-center',
      render: (text, record) => (
        <>
          {text !== 0 && !record.isTotal ? (
            <a
              href={getRedirectUrl(`${route}/leads?user_id=${record?.user_id}&lead_stage=3&key=hot_lead`)}
              style={{ cursor: 'pointer' }}
            >
              {text}
            </a>
          ) : (
            text
          )}
        </>
      ),
    },
    {
      title: 'Exchange',
      dataIndex: 'exchange',
      key: 'exchange',
      className: 'text-center',
      render: (text, record) => (
        <>
          {text !== 0 && !record.isTotal ? (
            <a
              href={getRedirectUrl(`${route}/leads?user_id=${record?.user_id}&key=hot_lead&exchange_car="true"`)}
              style={{ cursor: 'pointer' }}
            >
              {text}
            </a>
          ) : (
            text
          )}
        </>
      ),
    },
    {
      title: 'Valuation',
      dataIndex: 'valuation',
      key: 'valuation',
      className: 'text-center',
      render: (text, record) => (
        <>
          {text !== 0 && !record.isTotal ? (
            <a
              href={getRedirectUrl(`${route}/leads?user_id=${record?.user_id}&key=hot_lead&evaluation_completed="true"`)}
              style={{ cursor: 'pointer' }}
            >
              {text}
            </a>
          ) : (
            text
          )}
        </>
      ),
    },
    {
      title: 'Procured',
      dataIndex: 'procured',
      key: 'procured',
      className: 'text-center',
      render: (text, record) => (
        <>
          {text !== 0 && !record.isTotal ? (
            <a
              href={getRedirectUrl(`${route}/leads?user_id=${record?.user_id}&procured="true"&key=hot_lead`)}
              style={{ cursor: 'pointer' }}
            >
              {text}
            </a>
          ) : (
            text
          )}
        </>
      ),
    },
    {
      title: 'Lost',
      dataIndex: 'lost',
      key: 'lost',
      className: 'text-center',
      render: (text, record) => (
        <>
          {text !== 0 && !record.isTotal ? (
            <a
              href={getRedirectUrl(`${route}/leads?user_id=${record?.user_id}&lead_status=3&key=hot_lead`)}
              style={{ cursor: 'pointer' }}
            >
              {text}
            </a>
          ) : (
            text
          )}
        </>
      ),
    },
  ];

  // Team Leader User Table columns
  const columnsTeamLeaderUserTable = [
    {
      title: 'Lead Owner',
      dataIndex: 'leadOwner',
      key: 'leadOwner',
    },
    {
      title: 'Enquiry',
      dataIndex: 'enquiry',
      key: 'enquiry',
      className: 'text-center',
      render: (text, record) => (
        <>
          {text !== 0 && !record.isTotal ? (
            <a
              href={getRedirectUrl(`${route}/leads?user_id=${record?.user_id}&key=hot_lead`)}
              style={{ cursor: 'pointer' }}
            >
              {text}
            </a>
          ) : (
            text
          )}
        </>
      ),
    },
    {
      title: 'Test Drive',
      dataIndex: 'test_drive',
      key: 'test_drive',
      className: 'text-center',
      render: (text, record) => (
        <>
          {text !== 0 && !record.isTotal ? (
            <a
              href={getRedirectUrl(`${route}/leads?user_id=${record?.user_id}&key=hot_lead&test_drive_completed="true"`)}
              style={{ cursor: 'pointer' }}
            >
              {text}
            </a>
          ) : (
            text
          )}
        </>
      ),
    },
    {
      title: 'Home Visit',
      dataIndex: 'home_visit',
      key: 'home_visit',
      className: 'text-center',
      render: (text, record) => (
        <>
          {text !== 0 && !record.isTotal ? (
            <a
              href={getRedirectUrl(`${route}/leads?user_id=${record?.user_id}&key=hot_lead&home_visit_completed="true"`)}
              style={{ cursor: 'pointer' }}
            >
              {text}
            </a>
          ) : (
            text
          )}
        </>
      ),
    },
    {
      title: 'Booking',
      dataIndex: 'booking',
      key: 'booking',
      className: 'text-center',
      render: (text, record) => (
        <>
          {text !== 0 && !record.isTotal ? (
            <a
              href={getRedirectUrl(`${route}/leads?user_id=${record?.user_id}&key=hot_lead&booking_completed="true"`)}
              style={{ cursor: 'pointer' }}
            >
              {text}
            </a>
          ) : (
            text
          )}
        </>
      ),
    },
    {
      title: 'Retail',
      dataIndex: 'retail',
      key: 'retail',
      className: 'text-center',
      render: (text, record) => (
        <>
          {text !== 0 && !record.isTotal ? (
            <a
              href={getRedirectUrl(`${route}/leads?user_id=${record?.user_id}&lead_stage=3&key=hot_lead`)}
              style={{ cursor: 'pointer' }}
            >
              {text}
            </a>
          ) : (
            text
          )}
        </>
      ),
    },
    {
      title: 'Exchange',
      dataIndex: 'exchange',
      key: 'exchange',
      className: 'text-center',
      render: (text, record) => (
        <>
          {text !== 0 && !record.isTotal ? (
            <a
              href={getRedirectUrl(`${route}/leads?user_id=${record?.user_id}&key=hot_lead&exchange_car="true"`)}
              style={{ cursor: 'pointer' }}
            >
              {text}
            </a>
          ) : (
            text
          )}
        </>
      ),
    },
    {
      title: 'Valuation',
      dataIndex: 'valuation',
      key: 'valuation',
      className: 'text-center',
      render: (text, record) => (
        <>
          {text !== 0 && !record.isTotal ? (
            <a
              href={getRedirectUrl(`${route}/leads?user_id=${record?.user_id}&key=hot_lead&evaluation_completed="true"`)}
              style={{ cursor: 'pointer' }}
            >
              {text}
            </a>
          ) : (
            text
          )}
        </>
      ),
    },
    {
      title: 'Procured',
      dataIndex: 'procured',
      key: 'procured',
      className: 'text-center',
      render: (text, record) => (
        <>
          {text !== 0 && !record.isTotal ? (
            <a
              href={getRedirectUrl(`${route}/leads?user_id=${record?.user_id}&procured="true"&key=hot_lead`)}
              style={{ cursor: 'pointer' }}
            >
              {text}
            </a>
          ) : (
            text
          )}
        </>
      ),
    },
    {
      title: 'Lost',
      dataIndex: 'lost',
      key: 'lost',
      className: 'text-center',
      render: (text, record) => (
        <>
          {text !== 0 && !record.isTotal ? (
            <a
              href={getRedirectUrl(`${route}/leads?user_id=${record?.user_id}&lead_status=3&key=hot_lead`)}
              style={{ cursor: 'pointer' }}
            >
              {text}
            </a>
          ) : (
            text
          )}
        </>
      ),
    },
  ];

  // Prepare user table data for Sales Manager
  const prepareSalesManagerUserTableData = () => {
    if (!dashboardHomeData?.user_table?.data) return [];
    
    const flattenedData = [];
    
    dashboardHomeData?.user_table?.data?.forEach((teamLeaderData, teamIndex) => {
      // Track the starting index for this team leader's rows
      const teamStartIndex = flattenedData.length;
      let teamRowCount = 0;
      
      // Add lead owners first
      teamLeaderData?.leadOwners?.forEach(leadOwner => {
        flattenedData.push({
          key: `lead_${leadOwner?.user_id}_${teamIndex}`,
          teamLeader: '',  // Will be filled by rowSpan
          leadOwner: leadOwner?.user_name,
          user_id: leadOwner?.user_id,
          enquiry: leadOwner?.enquiry,
          test_drive: leadOwner?.test_drive,
          home_visit: leadOwner?.home_visit,
          booking: leadOwner?.booking,
          retail: leadOwner?.retail,
          exchange: leadOwner?.exchange,
          valuation: leadOwner?.valuation,
          procured: leadOwner?.procured,
          lost: leadOwner?.lost,
        });
        teamRowCount++;
      });
      
      // Add team leader row after lead owners
      flattenedData.push({
        key: `team_leader_${teamLeaderData?.total?.user_id}_${teamIndex}`,
        teamLeader: `${teamLeaderData?.teamLeader} Total`,
        leadOwner: '',
        user_id: teamLeaderData?.total?.user_id,
        enquiry: teamLeaderData?.total?.enquiry,
        test_drive: teamLeaderData?.total?.test_drive,
        home_visit: teamLeaderData?.total?.home_visit,
        booking: teamLeaderData?.total?.booking,
        retail: teamLeaderData?.total?.retail,
        exchange: teamLeaderData?.total?.exchange,
        valuation: teamLeaderData?.total?.valuation,
        procured: teamLeaderData?.total?.procured,
        lost: teamLeaderData?.total?.lost,
        isTotal: true, // Flag for styling
      });
      teamRowCount++;
      
      // Set the team leader name only in the first row with rowSpan
      if (teamRowCount > 0 && flattenedData[teamStartIndex]) {
        flattenedData[teamStartIndex].teamLeader = teamLeaderData?.teamLeader;
        flattenedData[teamStartIndex].teamLeaderRowSpan = teamRowCount - 1; // Exclude the total row which shows the name again
      }
    });
    
    // Add grand total row
    if (dashboardHomeData?.user_table?.grandTotal) {
      flattenedData.push({
        key: 'grand_total',       
        teamLeader: dashboardHomeData?.user_table?.grandTotal?.user_name,
        leadOwner: '',
        user_id: '',
        enquiry: dashboardHomeData?.user_table?.grandTotal?.enquiry,
        test_drive: dashboardHomeData?.user_table?.grandTotal?.test_drive,
        home_visit: dashboardHomeData?.user_table?.grandTotal?.home_visit,
        booking: dashboardHomeData?.user_table?.grandTotal?.booking,
        retail: dashboardHomeData?.user_table?.grandTotal?.retail,
        exchange: dashboardHomeData?.user_table?.grandTotal?.exchange,
        valuation: dashboardHomeData?.user_table?.grandTotal?.valuation,
        procured: dashboardHomeData?.user_table?.grandTotal?.procured,
        lost: dashboardHomeData?.user_table?.grandTotal?.lost,
        isTotal: true, // Flag for styling
      });
    }
    
    return flattenedData;
  };

  // Prepare user table data for Team Leader
  const prepareTeamLeaderUserTableData = () => {
    if (!dashboardHomeData?.user_table?.data) return [];
    
    const flattenedData = [];
    
    // Add lead owners first
    dashboardHomeData?.user_table?.data?.forEach(leadOwner => {
      flattenedData.push({
        key: `lead_${leadOwner?.user_id}`,
        leadOwner: leadOwner?.user_name,
        user_id: leadOwner?.user_id,
        enquiry: leadOwner?.enquiry,
        test_drive: leadOwner?.test_drive,
        home_visit: leadOwner?.home_visit,
        booking: leadOwner?.booking,
        retail: leadOwner?.retail,
        exchange: leadOwner?.exchange,
        valuation: leadOwner?.valuation,
        procured: leadOwner?.procured,
        lost: leadOwner?.lost,
      });
    });
    
    // Add grand total row at the end
    if (dashboardHomeData?.user_table?.grandTotal) {
      flattenedData.push({
        key: 'grand_total',
        leadOwner: dashboardHomeData?.user_table?.grandTotal?.user_name,
        user_id: '',
        enquiry: dashboardHomeData?.user_table?.grandTotal?.enquiry,
        test_drive: dashboardHomeData?.user_table?.grandTotal?.test_drive,
        home_visit: dashboardHomeData?.user_table?.grandTotal?.home_visit,
        booking: dashboardHomeData?.user_table?.grandTotal?.booking,
        retail: dashboardHomeData?.user_table?.grandTotal?.retail,
        exchange: dashboardHomeData?.user_table?.grandTotal?.exchange,
        valuation: dashboardHomeData?.user_table?.grandTotal?.valuation,
        procured: dashboardHomeData?.user_table?.grandTotal?.procured,
        lost: dashboardHomeData?.user_table?.grandTotal?.lost,
        isTotal: true, // Flag for styling
      });
    }
    
    return flattenedData;
  };

  // Exchange Evaluation Users Table Column
  const columnsExchangeEvaluationUsers = [
    {
      title: 'Area Name',
      dataIndex: 'area_name',
      key: 'area_name',
      render: (text, record, index) => {
        // Show area name only for the first row of each area group
        if (index === 0 || text !== record.previousAreaName) {
          return record.area_name === 'Total' || record.user_name === 'Total' ? (
            <span style={{ fontWeight: 'bold' }}>{text}</span>
          ) : (
            text
          );
        }
        return '';
      },
    },
    {
      title: 'User Name',
      dataIndex: 'user_name',
      key: 'user_name',
      render: (text, record) => (
        record.area_name === 'Total' || record.user_name === 'Total' ? (
          <span style={{ fontWeight: 'bold' }}>{text}</span>
        ) : (
          text
        )
      ),
    },
    {
      title: 'Pending for Evaluation (Prev Month)',
      dataIndex: 'pending_for_evaluation_prev_month',
      key: 'pending_for_evaluation_prev_month',
      className: 'text-center',
      render: (text, record) => (
        <>
          {record.area_name === 'Total' || record.user_name === 'Total' ? (
            <span style={{ fontWeight: 'bold' }}>{text}</span>
          ) : (
            <>
              {+text !== 0 ? (
                <a
                  href={getRedirectUrl(`${route}/leads${exchangeRoute}?key=hot_lead&area_id[0]=${record?.area_id}&lead_owned[0]=${record?.user_id}&lead_owner_name=${record?.user_name}&lead_exchange_stage_id=1&lead_exchange_stage_name=${encodeURIComponent('Pending for Evaluation (Prev Month)')}&last_month=true`)}
                  style={{ cursor: 'pointer' }}
                >
                  {text}
                </a>
              ) : (
                text
              )}
            </>
          )}
        </>
      ),
    },
    {
      title: 'Pending for Evaluation (Current Month)',
      dataIndex: 'pending_for_evaluation_current_month',
      key: 'pending_for_evaluation_current_month',
      className: 'text-center',
      render: (text, record) => (
        <>
          {record.area_name === 'Total' || record.user_name === 'Total' ? (
            <span style={{ fontWeight: 'bold' }}>{text}</span>
          ) : (
            <>
              {+text !== 0 ? (
                <a
                  href={getRedirectUrl(`${route}/leads${exchangeRoute}?key=hot_lead&area_id[0]=${record?.area_id}&lead_owned[0]=${record?.user_id}&lead_owner_name=${record?.user_name}&lead_exchange_stage_id=1&lead_exchange_stage_name=${encodeURIComponent('Pending for Evaluation (Current Month)')}&current_month=true`)}
                  style={{ cursor: 'pointer' }}
                >
                  {text}
                </a>
              ) : (
                text
              )}
            </>
          )}
        </>
      ),
    },
    {
      title: 'Pre Evaluation',
      dataIndex: 'pre_evaluation',
      key: 'pre_evaluation',
      className: 'text-center',
      render: (text, record) => (
        <>
          {record.area_name === 'Total' || record.user_name === 'Total' ? (
            <span style={{ fontWeight: 'bold' }}>{text}</span>
          ) : (
            <>
              {+text !== 0 ? (
                <a
                  href={getRedirectUrl(`${route}/leads${exchangeRoute}?key=hot_lead&area_id[0]=${record?.area_id}&lead_owned[0]=${record?.user_id}&lead_owner_name=${record?.user_name}&lead_exchange_stage_id=2&lead_exchange_stage_name=${encodeURIComponent('Pre Evaluation')}`)}
                  style={{ cursor: 'pointer' }}
                >
                  {text}
                </a>
              ) : (
                text
              )}
            </>
          )}
        </>
      ),
    },
    {
      title: 'Re Evaluation',
      dataIndex: 're_evaluation',
      key: 're_evaluation',
      className: 'text-center',
      render: (text, record) => (
        <>
          {record.area_name === 'Total' || record.user_name === 'Total' ? (
            <span style={{ fontWeight: 'bold' }}>{text}</span>
          ) : (
            <>
              {+text !== 0 ? (
                <a
                  href={getRedirectUrl(`${route}/leads${exchangeRoute}?key=hot_lead&area_id[0]=${record?.area_id}&lead_owned[0]=${record?.user_id}&lead_owner_name=${record?.user_name}&lead_exchange_stage_id=4&lead_exchange_stage_name=${encodeURIComponent('Re Evaluation')}`)}
                  style={{ cursor: 'pointer' }}
                >
                  {text}
                </a>
              ) : (
                text
              )}
            </>
          )}
        </>
      ),
    },
    {
      title: 'Pre Final Assessment',
      dataIndex: 'pre_final_assessment',
      key: 'pre_final_assessment',
      className: 'text-center',
      render: (text, record) => (
        <>
          {record.area_name === 'Total' || record.user_name === 'Total' ? (
            <span style={{ fontWeight: 'bold' }}>{text}</span>
          ) : (
            <>
              {+text !== 0 ? (
                <a
                  href={getRedirectUrl(`${route}/leads${exchangeRoute}?key=hot_lead&area_id[0]=${record?.area_id}&lead_owned[0]=${record?.user_id}&lead_owner_name=${record?.user_name}&lead_exchange_stage_id=6&lead_exchange_stage_name=${encodeURIComponent('Pre Final Assessment')}`)}
                  style={{ cursor: 'pointer' }}
                >
                  {text}
                </a>
              ) : (
                text
              )}
            </>
          )}
        </>
      ),
    },
    {
      title: 'Final Assessment Completed',
      dataIndex: 'final_assessment_completed',
      key: 'final_assessment_completed',
      className: 'text-center',
      render: (text, record) => (
        <>
          {record.area_name === 'Total' || record.user_name === 'Total' ? (
            <span style={{ fontWeight: 'bold' }}>{text}</span>
          ) : (
            <>
              {+text !== 0 ? (
                <a
                  href={getRedirectUrl(`${route}/leads${exchangeRoute}?key=hot_lead&area_id[0]=${record?.area_id}&lead_owned[0]=${record?.user_id}&lead_owner_name=${record?.user_name}&lead_exchange_stage_id=7&lead_exchange_stage_name=${encodeURIComponent('Final Assessment Completed')}`)}
                  style={{ cursor: 'pointer' }}
                >
                  {text}
                </a>
              ) : (
                text
              )}
            </>
          )}
        </>
      ),
    },
    {
      title: 'Procured',
      dataIndex: 'procured',
      key: 'procured',
      className: 'text-center',
      render: (text, record) => (
        <>
          {record.area_name === 'Total' || record.user_name === 'Total' ? (
            <span style={{ fontWeight: 'bold' }}>{text}</span>
          ) : (
            <>
              {+text !== 0 ? (
                <a
                  href={getRedirectUrl(`${route}/leads${exchangeRoute}?key=hot_lead&area_id[0]=${record?.area_id}&lead_owned[0]=${record?.user_id}&lead_owner_name=${record?.user_name}&procured=true`)}
                  style={{ cursor: 'pointer' }}
                >
                  {text}
                </a>
              ) : (
                text
              )}
            </>
          )}
        </>
      ),
    },
  ];

  // Prepare Exchange Evaluation Users table data
  const prepareExchangeEvaluationUsersTableData = () => {
    if (!dashboardHomeData?.exchange_evaluation_users_table) return [];
    
    const flattenedData = [];
    let previousAreaName = '';
    
    dashboardHomeData?.exchange_evaluation_users_table?.forEach((areaData) => {
      // Add each sales officer
      areaData?.salesOfficers?.forEach((officer, officerIndex) => {
        flattenedData.push({
          key: `area_${areaData?.area_id}_officer_${officerIndex}`,
          area_id: areaData?.area_id,
          area_name: areaData?.area_name,
          previousAreaName: previousAreaName,
          user_name: officer?.user_name,
          user_id: officer?.user_id,
          pending_for_evaluation_prev_month: officer?.pending_for_evaluation_prev_month,
          pending_for_evaluation_current_month: officer?.pending_for_evaluation_current_month,
          pre_evaluation: officer?.pre_evaluation,
          re_evaluation: officer?.re_evaluation,
          pre_final_assessment: officer?.pre_final_assessment,
          final_assessment_completed: officer?.final_assessment_completed,
          procured: officer?.procured,
          isTotal: officer?.user_name === 'Total', // Correct flag for total rows
        });
        
        // Update previousAreaName only for non-total rows
        if (officer?.user_name !== 'Total') {
          previousAreaName = areaData?.area_name;
        }
      });
    });
    
    return flattenedData;
  };

  // Check if user is Head Office Manager
  const isHeadOfficeManager = roleType === 'Head Office Manager';

  return (
    <>
      <Loader loading={isLoading} />
      <div className='user-data p-0'>
        {/* <div className="user-table-head pb-3 d-flex justify-content-between align-items-center">
                    <div className="user-right">
                        <Space size="middle">
                            <Button icon={<FilterFilled />} />
                        </Space>
                    </div>
                </div> */}

        {/* Head Office Manager - Only Task of The Day */}
        {isHeadOfficeManager ? (
          <Row gutter={20}>
            <Col xl={12} lg={24} md={12} sm={24} xs={24} className='mb-4'>
              <Card className='me-lg-3'>
                <div className='day-task'>
                  <div className='user-left'>
                    <h5 className='pb-3'>Task of The Day</h5>
                  </div>
                  <div className='task-wrapper'>
                    <Row gutter={[20, 20]} justify='center'>
                      {Object.entries(dashboardHomeData?.task_of_the_day || {}).map(([key, value]) => (
                        <Col xl={12} lg={12} md={24} sm={24} xs={24} className='mb-lg-0 mb-md-3' key={key}>
                          <Card
                            className='text-center cursor-pointer'
                            onClick={() => {
                              +value !== 0 && handleCardClick(formatKeyName(key), key);
                            }}
                          >
                            <p>{value}</p>
                            <span>{formatKeyName(key)}</span>
                          </Card>
                        </Col>
                      ))}
                    </Row>
                  </div>
                </div>
              </Card>
            </Col>
          </Row>
        ) : (
          <>
            <Filters onFiltersChange={setFilters} heading={'Home'} />

            {/* Dashboard Tiles - Display for all users */}
            <Row gutter={[20, 20]} className="mb-4">
              <Col xl={6} lg={12} md={12} sm={24} xs={24}>
                <Card className="text-center">
                  <p style={{ color: '#0a9551', fontSize: '28px', fontWeight: 'bold' }}>{dashboardHomeData?.evaluation_ratio || 0}%</p>
                  <span  style={{ fontWeight: '500' }}>Evaluation Ratio</span>
                </Card>
              </Col>
              <Col xl={6} lg={12} md={12} sm={24} xs={24}>
                <Card className="text-center">
                  <p style={{ color: '#0a9551', fontSize: '28px', fontWeight: 'bold' }}>{dashboardHomeData?.procurement_ratio || 0}%</p>
                  <span style={{ fontWeight: '500' }}>Procurement Ratio</span>
                </Card>
              </Col>
              <Col xl={6} lg={12} md={12} sm={24} xs={24}>
                <Card className="text-center">
                  <p style={{ color: '#0a9551', fontSize: '28px', fontWeight: 'bold' }}>{dashboardHomeData?.pending_for_evaluation_out_of_tat || 0}</p>
                  <span style={{ fontWeight: '500' }}>Pending Evaluation Out of TAT (Current Month)</span>
                </Card>
              </Col>
              <Col xl={6} lg={12} md={12} sm={24} xs={24}>
                <Card className="text-center">
                  <p style={{ color: '#0a9551', fontSize: '28px', fontWeight: 'bold' }}>{dashboardHomeData?.evaluation_completed_out_of_tat || 0}</p>
                  <span style={{ fontWeight: '500' }}>Evaluations Completed Out of TAT (Current Month)</span>
                </Card>
              </Col>
            </Row>

            <Row gutter={20}>
              {/* Task of The Day */}
              <Col xl={12} lg={24} md={12} sm={24} xs={24} className='mb-4'>
                <Card className='me-lg-3'>
                  <div className='day-task'>
                    <div className='user-left'>
                      <h5 className='pb-3'>Task of The Day</h5>
                    </div>
                    <div className='task-wrapper'>
                      <Row gutter={[20, 20]} justify='center'>
                        {Object.entries(dashboardHomeData?.task_of_the_day || {}).map(([key, value]) => (
                          <Col xl={12} lg={12} md={24} sm={24} xs={24} className='mb-lg-0 mb-md-3' key={key}>
                            <Card
                              className='text-center cursor-pointer'
                              onClick={() => {
                                +value !== 0 && handleCardClick(formatKeyName(key));
                              }}
                            >
                              <p>{value}</p>
                              <span>{formatKeyName(key)}</span>
                            </Card>
                          </Col>
                        ))}
                      </Row>
                    </div>
                  </div>
                </Card>
              </Col>

          {/* Task Ageing Table */}
          {roleType === 'Exchange Evaluation Team' || roleType === "Procurement Manager" ? (
            ''
          ) : (
            <>
              <Col xl={12} lg={24} md={12} sm={24} xs={24} className='mb-4'>
                <Card className='ms-lg-3'>
                  <div className='user-table-data'>
                    <div className='user-left'>
                      <h5 className='pb-3'>Task Ageing Table</h5>
                    </div>
                    <div className='responsive-table-container'>
                      <Table
                        columns={task_ageing_column}
                        dataSource={dashboardHomeData?.task_ageing}
                        pagination={false}
                      />
                    </div>
                  </div>
                </Card>
              </Col>
            </>
          )}

          {/* Lead Funel (Lead Type) */}
          <Col xl={12} lg={12} md={12} sm={24} xs={24} className='mb-4'>
            <Card className='ms-lg-3'>
              <div className='lead-funel-type'>
                <div className='user-left'>
                  <h5 className='pb-3'>Lead Funel (Lead Type)</h5>
                </div>
                <div className='lead-funel-type-wrapper'>
                  <PieChart onSegmentClick={onPieChartSegmentClick} data={dataChartLeadType} />
                </div>
              </div>
            </Card>
          </Col>

          {/* Lead Funel (Lead Stage) */}
          <Col xl={12} lg={12} md={12} sm={24} xs={24} className='mb-4'>
            <Card className='me-lg-3'>
              <div className='lead-funel-stage'>
                <div className='user-left'>
                  <h5 className='pb-3'>Lead Funel (Lead Stage)</h5>
                </div>
                <div className='lead-funel-stage-wrapper'>
                  <PieChart
                    data={dataChartLeadStage}
                    onSegmentClick={onPieChartSegmentClick}
                    chartColors={['#f8b743', '#83eea6', '#eca7ee', '#94c9f1']}
                  />
                </div>
              </div>
            </Card>
          </Col>

          {/* Lead-bar-chart */}
          {roleType === 'Exchange Evaluation Team' || roleType === "Procurement Manager" ? (
            ''
          ) : (
            <Col xl={24} lg={24} md={24} sm={24} xs={24} className='mb-4'>
              <Card className='me-lg-3'>
                <div className='user-table-data'>
                  <div className='lead-bar-chart'>
                    <ColumnChart data={formattedChartData} />
                  </div>
                </div>
              </Card>
            </Col>
          )}

          {/* lead-line-chart */}
          {roleType === 'Exchange Evaluation Team' || roleType === "Procurement Manager" ? (
            ''
          ) : (
            <>
              {dashboardHomeData && dashboardHomeData?.retail_breakup?.length !== 0 && (
                <Col xl={24} lg={24} md={24} sm={24} xs={24} className='mb-4'>
                  <Card className=''>
                    <div className='user-table-data'>
                      <div className='user-left'>
                        <h5 className='pb-3 text-center'>Last Month Delivery Breakup</h5>
                      </div>
                      <div className='lead-line-chart'>
                        <LineChart
                          fullRetailData={dashboardHomeData && dashboardHomeData?.retail_breakup}
                          data={formattedRetailerData}
                          chartColors={['#94959B']}
                          heading={'Last Month Delivery Breakup'}
                        />
                      </div>
                    </div>
                  </Card>
                </Col>
              )}
            </>
          )}
  {/* Area Table */}
          {shouldHideAreaTable ? (
            ''
          ) : (
            <Col xl={24} lg={24} md={24} sm={24} xs={24} className="mb-4">
              <div className='user-table-data'>
                <div className='user-left'>
                  <h5 className='pb-3'>Area Table</h5>
                </div>
                <div className='responsive-table-container'>
                  <Table
                    columns={columnsArea}
                    dataSource={dashboardHomeData?.area_table}
                    pagination={false}
                  />
                </div>
              </div>
            </Col>
          )}
          {/* User Table - Only for Super Admin or Sales Manager */}
          {shouldShowUserTable && (
            <Col xl={24} lg={24} md={24} sm={24} xs={24} className="mb-4">
              <div className='user-table-data'>
                <div className='user-left'>
                  <h5 className='pb-3'>Lead Owner Table</h5>
                </div>
                <div className='responsive-table-container'>
                  {isSuperAdmin ? (
                    <Table
                      columns={columnsUserTable}
                      dataSource={prepareUserTableData()}
                      pagination={false}
                      rowClassName={(record) => record.isTotal ? 'total-row' : ''}
                      bordered
                    />
                  ) : isSalesManager && !isTeamLeader ? (
                    <Table
                      columns={columnsSalesManagerUserTable}
                      dataSource={prepareSalesManagerUserTableData()}
                      pagination={false}
                      rowClassName={(record) => record.isTotal ? 'total-row' : ''}
                      bordered
                    />
                  ) : isTeamLeader && (
                    <Table
                      columns={columnsTeamLeaderUserTable}
                      dataSource={prepareTeamLeaderUserTableData()}
                      pagination={false}
                      rowClassName={(record) => record.isTotal ? 'total-row' : ''}
                      bordered
                    />
                  )}
                </div>
              </div>
            </Col>
          )}

        

          {/* Model Table */}
          {roleType === 'Exchange Evaluation Team' || roleType === "Procurement Manager" ? (
            ''
          ) : (
            <Col xl={24} lg={24} md={24} sm={24} xs={24} className="mb-4">
              <div className='user-table-data'>
                <div className='user-left'>
                  <h5 className='pb-3'>Model Table</h5>
                </div>
                <div className='responsive-table-container'>
                  <Table
                    columns={columnsModel}
                    dataSource={dashboardHomeData?.model_table}
                    pagination={false}
                  />
                </div>
              </div>
            </Col>
          )}
  {/* Enquiry Source Table */}
          {roleType === 'Exchange Evaluation Team' || roleType === "Procurement Manager"? (
            ''
          ) : (
            <Col xl={24} lg={24} md={24} sm={24} xs={24} className="mb-4">
              <div className='user-table-data'>
                <div className='user-left'>
                  <h5 className='pb-3'>Enquiry Source Table</h5>
                </div>
                <div className='responsive-table-container'>
                  <Table
                    columns={columnsEnquiry}
                    dataSource={dashboardHomeData?.enquiry_source_table}
                    pagination={false}
                  />
                </div>
              </div>
            </Col>
          )}

          {/* Exchange Evaluation Users Table - Only for Exchange Evaluation Team and Procurement Manager */}
          {(roleType === 'Exchange Evaluation Team' || roleType === 'Procurement Manager') && (
            <Col xl={24} lg={24} md={24} sm={24} xs={24} className="mb-4">
              <div className='user-table-data'>
                <div className='user-left'>
                  <h5 className='pb-3'>Exchange Evaluation Table</h5>
                </div>
                <div className='responsive-table-container'>
                  <Table
                    columns={columnsExchangeEvaluationUsers}
                    dataSource={prepareExchangeEvaluationUsersTableData()}
                    pagination={false}
                    rowClassName={(record) => record.isTotal ? 'total-row' : ''}
                    bordered
                  />
                </div>
              </div>
            </Col>
          )}
        
            </Row>
          </>
        )}
      </div>
    </>
  );
};

export default DashboardHome;
